<template>
  <v-card :loading="loading" class="p-5 col-md-12">
    <v-row v-if="!loading" class="mx-auto pa-2" no-gutters>
      <v-col class="pa-2" cols="12" md="4">
        <component
          :is="theme"
          v-model="data.data"
          :data="data.data"
          :orders.sync="orders"
          class="sticky-md"
          style="top: 110px"
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="8">
        <template>
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات کارت ویزیت</p>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <v-text-field
                    v-model="data.data.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام کارت ویزیت شما"
                    outlined
                  />
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion
                flat
                icon="pencil-ruler"
                single
                title="انتخاب طرح قالب"
              >
                <template v-slot:content>
                  <theme-selector v-model="theme" :components="customTheme" />
                </template>
              </list-expansion>
              <list-expansion
                v-model="data.data"
                :components="specialInfo"
                :data="data.data"
              />
              <qr-generator v-model="data.data" />

              <div class="col-md-12">
                <next-btn @click="markQr(true)" />
              </div>
            </v-stepper-content>
          </v-stepper>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ThemeSelector from "@/view/pages/qrland/components/themes/themeSelector";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import PrevBtn from "@/view/content/fragments/prevBtn";
import NextBtn from "@/view/content/fragments/nextBtn";
import ListExpansion from "@/view/content/fragments/listExpansion";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrGenerator from "@/view/pages/qrland/components/qrGenerator";
import MobileViwer from "@/view/pages/qrland/components/mobileViwer";
import { Bus } from "@/main";
import { mapActions } from "vuex";

export default {
  name: "editModel",

  props:{
    id:{type:String, default:''},
  },

  components: {
    ThemeSelector,
    VisitThemeTwo,
    VisitThemeFlipped,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
  },

  data() {
    return {
      showDialog: false,
      data: {},
      orders: [],
      finish: false,
      loading: false,
      e6: 1,
      security: {},
      dtUrl: null,
      theme: "",
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      specialInfo: [
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
      ],
      res: {},
    };
  },

  mounted() {
    Bus.$on("colorPalette", (value) => {
      this.data.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.data.isGradient = value;
    });

    this.fetchData();
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    fetchData() {
      this.loading = true;
      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          this.loading = false;
          this.data =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;
          this.theme =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data).theme
              : data.data.qr.data.theme;
          this.res = data;
          this.setCreatedQrID(data.data.id);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "VisitCard",
        qrType: "dynamic",
        title: this.data.data.visitName,
        data: JSON.stringify({
          theme: this.theme,
          data: this.data.data,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "VisitCard",
          title: this.data.data.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("کارت ویزیت شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
